module.exports = "<button class=\" btn _matinet_btn_close filte_width\" (click)=\"resetfn.emit()\">Reset</button>"